export default {
  QuotationCenter: {
    supplier: 'Supplier',
    logisticsChannel: 'Logistics Channel',
    effectiveTime: 'Effective Time',
    status: 'Status',
    effectiveStatus: 'Effective Status',
    Expired: 'Expired',
    Active: 'Active',
    currency: 'Currency',
    startTime: 'Start Time',
    endTime: 'End Time',
    updateTime: 'Update Time',
    creater: 'Create By',
    updateBy: 'Update By',
    Details: 'Quotation Details',
    status1: 'Enabled',
    status2: 'Pending Activation',
    status3: 'Disabled',
    serialNumber: 'No.',
    zone: 'Zone',
    start: 'Start',
    end: 'End',
    unitWeight: 'Unit Weight',
    amount: 'Amount',
    shippingFee: 'Shipping Fee',
    otherFee: 'Other Fees',
    edit: 'Edit',
    export: 'Export',
    trialCalculation: 'Trial Calculation',
    add: 'Add Fee Type',
    copyTips: 'Duplicate Logistics Channel',

    packageType: 'Package Type',
    calcMethod: 'Calculation Method',
    feeItem: 'Fee Type',
    billingType: 'Billing Type',
    chargeUnit: 'Charge Unit',
    calcFuel: 'Calculate Fuel Surcharge',

    components: {
      copyPasteMethod: 'Copy and Paste ( Method 1 )',
      copyPasteTip: '1. Copy the zone-to-weight price ranges from Excel (without headers) and paste them into the table; 2. Click the [Save] button.',
      back: 'Back',
      batchAdjustment: 'Batch Price Adjustment',
      clear: 'Clear',
      save: 'Save',
      roundingUnit: 'Rounding Unit',
      unitPrice: 'Unit Price',
      minimumCharge: 'Minimum Charge',
      addRow: 'Add Row',
      excelImportMethod: 'Excel Import ( Method 2 )',
      excelImportTip: '1. Click upload and select the zone weight price Excel file to import',
      clickUpload: 'Click to Upload',
      importTemplate: 'Import Template',
      onlySupportExcel: 'Only xls and xlsx files are supported!',
      importLog: 'Import Log',
      priceSample: 'Zone Price Range Sample',
      sampleData: 'Sample Data',
      adjustmentType: 'Adjustment Type',
      fixedAmountAdjustment: 'Fixed Amount',
      percentAdjustment: 'Percentage',
      fixedAmount: 'Fixed Amount',
      percentAmount: 'Percentage',
      adjustmentPlaceholder: 'Use a negative number to decrease, e.g. -10',
      close: 'Close',
      confirmAdjustment: 'Confirm Adjustment',
      packageTypeOutOfRange: 'Package type is out of range',
      zoneOnlyNumberAndEnglish: 'Zone can only contain English letters, numbers, or spaces',
      calcMethodOutOfRange: 'Calculation method is out of range',
      roundingUnitMaxThreeDecimals: 'Rounding unit can keep up to three decimal places',
      maxTwoDecimals: 'Keep up to two decimal places',
      maxThreeDecimals: 'Keep up to three decimal places',
      maxInput: 'Maximum input {max}',
      unitPriceMaxTwoDecimals: 'Unit price can keep up to four decimal places',
      unitPriceCannotBeZero: 'Unit price cannot be 0',
      minimumChargeMustGreaterThanZero: 'Minimum charge must be greater than 0',
      startWeightMaxThreeDecimals: 'Start can keep up to three decimal places',
      endWeightMaxThreeDecimals: 'End can keep up to three decimal places',
      startWeightCannotGreaterEndWeight: 'Start cannot be greater than end',
      unitWeightCannotGreaterThanWeightRange: 'Unit weight ≤ End weight − Start weight',
      endWeightMustBeUnitWeightMultiple: 'End weight is an integer multiple of unit weight',
      correctUnitPriceFirst: 'Please correct the unit price first',
      adjustedUnitPriceMustGreaterThanZero: 'Adjusted unit price must be greater than 0',
      pasteSuccess: '{count} rows pasted successfully',
      feeType: 'Fee Type',
      country: 'Country',
      province: 'Province/State',
      city: 'City',
      postcode: 'Postcode',
      Pallets: 'Pallets',
      Tickets: 'Tickets',
      Hours: 'Hours',
      Items: 'Items',
      Times: 'Times',
      actualWeight: 'Actual Weight',
      specialGoodsType: 'Special Goods Type',
      size: 'L*W*H (CM)',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      declaredCurrency: 'Declared Currency',
      germanyExpressLine: 'Germany Express Line',
      generalGoods: 'General Goods',
      specialGoods: 'Special Goods',
      chargedGoods: 'Battery',
      liquidGoods: 'Liquid',
      powderGoods: 'Powder',
      taxFee: 'Tax Fee',
      quoteAmount: 'Quoted Amount',
      quoteSettlementWeight: 'Quote Settlement QTY',
      localCurrencyAmount: 'Local Currency Amount',
      systemSettlementWeight: 'System Settlement QTY',
      totalAmount: 'Total Amount',
    }
  }
};
